export default __webpack_public_path__ + "static/media/Pos6.93aa4095.svg";